import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import helpersTime from "../../../../helpers/time";
import TypeGroupSitePublisher from "./../TypeGroupSitePublisher";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

function AllCategoryUserSitePublisher() {
  const [groupUserSitePublisher, setGroupUserSitePublisher] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [nameCategorySearchFilter, setNameCategorySearchFilter] = useState();

  useEffect(() => {
    getGroupUserSitePublisher();
  }, []);

  useEffect(() => {
    getGroupUserSitePublisher();
  }, [currentPage, countItemPerPage, nameCategorySearchFilter]);

  const getGroupUserSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGroupUserSitePublisher =
      await sendRequestGetGroupUserSitePublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGroupUserSitePublisher) {
      return;
    }

    setGroupUserSitePublisher(
      resultSendRequestGetGroupUserSitePublisher.category_user_site_publishers
    );
    setCountPage(resultSendRequestGetGroupUserSitePublisher.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (nameCategorySearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${nameCategorySearchFilter}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTagGroupUserSitePublisher = () => {
    return (
      <>
        <div>
          <div className="alert alert-warning ">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p className="text-justify">
                  گروه نمایش دهنده از مجموعه از جایگاه هایی که تبلیغات را نمایش
                  میدهد تشکیل شده است.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  گروه نمایش دهنده شما توسط متخصصین تبلیغات و دیجیتال مارکتینگ
                  در حوزه صنعت و ساختمان با توجه به کسب و کار , استراتژی , هدف و
                  متناسب با بودجه شما انتخاب و برای تاریخ مدنظر کمپین تبلیغات
                  شما رزرو میشود..
                </p>
              </li>
            </ul>
          </div>

          <div class="container-fluid pb-2">
            <div class="row border border-1 rounded py-2">
              <div class="col-12 col-md-4">
                <div>
                  <label>جستجو در نام کمپین</label>
                </div>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="نام کمپین را در اینجا وارد کنید "
                    onKeyUp={(e) => setNameCategorySearchFilter(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive ">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره گروه نمایش دهنده</td>
                  <td>نام</td>
                  <td>نوع گروه</td>
                  <td>تاریخ درج گروه نمایش دهنده</td>
                  <td>عملیات</td>
                </tr>
              </thead>
              <tbody>
                {groupUserSitePublisher.length > 0 ? (
                  groupUserSitePublisher.map((group, index) => {
                    return (
                      <tr key={index}>
                        <td>{helperNumber.toPersianNum(index + 1)}</td>
                        <td>{helperNumber.toPersianNum(group.id)}</td>
                        <td>{group.name}</td>
                        <td>
                          {TypeGroupSitePublisher.getTypePersianNameGroupPublisher(
                            group.type
                          )}
                        </td>
                        <td>
                          {helperNumber.toPersianNum(
                            group.created_at.split(" ")[1] +
                              " " +
                              helpersTime.convertGregorianToJalali(
                                group.created_at.split(" ")[0]
                              )
                          )}
                        </td>
                        <td>
                          <div>
                            <span className="pl-2">
                              <Link
                                to={`/category-user-site-publisher/customer/${group.id}`}
                                className="btn btn-info  "
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colspan="100%"
                      className="text-center"
                      style={{ borderBottomRightRadius: "25px" }}
                    >
                      با این مشخصات گروه نمایش دهنده ای موجود نیست.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateDoNotHaveCategoryUserSitePublisherUserTag = () => {
    return (
      <div class="d-flex flex-column flex-md-row">
        <div class="text-center text-md-right">
          <img
            class="img-fluid"
            src="/assets/img/do-not-have-category-site-publisher.svg"
          />
        </div>
        <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p className="text-justify">
            شما در حال حاضر گروه نمایش دهنده ای ندارید.
          </p>
          <p className="text-justify">
            گروه نمایش دهنده از مجموعه از جایگاه هایی که تبلیغات را نمایش میدهد
            تشکیل شده است.
          </p>
        </div>
      </div>
    );
  };

  const sendRequestGetGroupUserSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/category-user-site-publishers-pagination?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar activeItem="site-publisher-coworker" />

      <div className="content-wrapper">
        <TitleBar title="گروه نمایش  دهنده ها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {groupUserSitePublisher.length == 0 &&
                nameCategorySearchFilter == null
                  ? generateDoNotHaveCategoryUserSitePublisherUserTag()
                  : generateTagGroupUserSitePublisher()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCategoryUserSitePublisher;
